const config = {
  name: 'crm-c52dc59039386c5d',
  rowKey: 'id',
  searchFormConfig: false,
  cacheDisabled: false,
  cacheType: "REMOTE",
  columns: [
    {
      title: '线索ID',
      dataIndex: 'id',
      fixed: 'left',
      width: 190,
      render:'clueIdRender'
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 200,
      ellipsis: true,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 160,
      render: 'checkPhone',
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 200,
    },
    {
      title: '公司',
      dataIndex: 'orgName',
      width: 160,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      ellipsis: true,
      width: 200,
    },
    {
      title: '优化师',
      dataIndex: 'advertName',
      width: 160,
    },
    {
      title: '创建日期',
      dataIndex: 'createdTime',
      itemType:"dateTime",
      width: 180,
    },
    {
      title: '无效次数',
      dataIndex: 'invalidCount',
      width: 120,
    },
    {
      title: '最近一次无效原因',
      dataIndex: 'reasonDesc',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: '#',
      render: 'operationCell',
      fixed: 'right',
      width: 150,
    },
  ],
  search: [
    {
      name: 'id',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      }
    },
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      itemType: 'number',
      label: '客户电话',
    },
    {
      name: 'channelIds',
      label: '客户来源',
      itemType: 'tree',
      data: 'channels',
      labelKey: 'label',
      key: 'id',
      treeCheckable: true,
      allowClear: true,
      showSearch: true,
    },
    // {
    //   name: 'advertWorkerNumber',
    //   label: '优化师工号',
    // },
    {
      name: 'orgId',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      allowClear: true,
      showSearch: true,
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'buildingId',
      label: '楼盘名称',
      itemType: 'select',
      data: 'buildingId',
      key: 'id',
      labelKey: 'name',
      notFoundContent: '请选择公司或暂无数据',
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'firstDate',
      label: '首访日期',
      itemType: 'autoDate',
      showTime: true,
    },
    {
      name: 'createDate',
      label: '创建日期',
      itemType: 'autoDate',
      showTime: true,
    },
    /*{
      name: 'reasonCode',
      label: '最近一个无效原因',
      itemType: 'cascader',
      data: 'reasonCode',
      key: 'code',
      value: 'code',
      labelKey: 'title',
      allowClear: true,
      showSearch: true,
      expandTrigger: 'hover',
    },*/
    {
      name: 'submitInvalidTime',
      label: '无效提交时间',
      itemType: 'autoDate',
      showTime: true,
    },
    {
      name: 'invalidCount',
      label: '无效次数',
      itemType: 'number',
    },
  ],
  batchActions: [
    {
      label: '批量领取',
      type: 'primary',
      render: 'allReceive',
    },
    {
      label: '批量指定分配',
      type: 'primary',
      render: 'assignDesignAll',
    },
  ],
}
export default config
